
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/faq",
      function () {
        return require("private-next-pages/ir/faq.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/faq"])
      });
    }
  